import { f as fetchHandler } from '../chuck/fetchHandler-BmcM6Yrg.js';

var getJson = function(url, origin) {
    if (origin === void 0) origin = window.location.origin;
    return function(headers, queryParams) {
        return fetchHandler("" + origin + url + (!!queryParams ? "?" + new URLSearchParams(queryParams) : ''), {
            method: 'GET',
            headers: headers != null ? headers : {},
            credentials: 'same-origin'
        }, 30000);
    };
};

export { getJson };
